import { render } from "./Login-popup.vue?vue&type=template&id=32d086cd&scoped=true"
import script from "./Login-popup.vue?vue&type=script&lang=js"
export * from "./Login-popup.vue?vue&type=script&lang=js"

import "./Login-popup.vue?vue&type=style&index=0&id=32d086cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d086cd"]])

export default __exports__